import '../sass/screen.scss'; // Import SASS for processing


import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';

let slickSlider;


jQuery(document).ready(function($) {



    $('#nav-toggle').click(function(){
        $('body').toggleClass('m-toggle');
    });   

    // -- testislider 

    // -- slick slider
    /*
     slickSlider = $('.testimonials__slider');
    if (slickSlider.length) {

        slickSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            arrows: true,
            fade: true,
            prevArrow:"<div class='anchor-action'><i class='fa-solid fa-arrow-left-long'></i></div>",
            nextArrow:"<div class='anchor-action'><i class='fa-solid fa-arrow-right-long'></i></div>",
            dots: false,
            appendArrows: $('.tcontrol-arrows'),
        });

    }
        */
    

})


document.addEventListener('DOMContentLoaded', () => {

   // Slider 1 – single item
  const hero = document.querySelector('.glide--hero')

  if (hero) {
    new Glide(hero, {
      type: 'carousel',
      perView: 1,
      gap: 0
    }).mount()
  }

  // Slider 2 – responsive multi item
  const multi = document.querySelector('.glide--dates')

  if (multi) {
    // -- set timeout to allow for rendering

    setTimeout(() => {

          new Glide(multi, {
            type: 'carousel',
            perView: 4,
            gap: 5,
            breakpoints: {
              1400: { perView: 3 },
              920:  { perView: 2 },
              480:  { perView: 1 }
            }
          }).mount()
        }
        , 1000);
  }


})


document.addEventListener('DOMContentLoaded', function () {

    let currentDepth = 0;
    let hasSetup = false;

    function initNav() {

        // -- are we less than 1301px
        if( window.innerWidth > 1300 ) return;


        if (hasSetup) return;
        console.log( "init Nav" );
        setUpBackButtons();
        setUpClickHandlers();
        hasSetup = true;
    }

    const setUpClickHandlers = () => {
        let hasChild = document.querySelectorAll('.menu-item-has-children > a');

        hasChild.forEach(function (item) {
            item.addEventListener('click', function (event) {
                console.log('clicked');
                event.preventDefault();

                let parent = this.parentElement;
                let sub = parent.querySelector('.sub-menu');

                console.log(sub);
                sub.classList.add('active');
            });
        });
    };

    const setUpBackButtons = () => {
        let subs = document.querySelectorAll('.menu-item-has-children ul');

        subs.forEach(function (item) {

        
            let back = document.createElement('li');
            back.classList.add('back');
            back.innerHTML = '<button class="back"><i class="bx bx-chevron-left"></i> Back</button>';
            item.insertBefore(back, item.firstChild);

            
            back.addEventListener('click', function (event) {
                event.preventDefault();
                this.parentElement.classList.remove('active');
            });
        });
    };

    if (window.innerWidth < 1300) {
        initNav();
    }

    // -- need a resize event to check if we need to re-init the nav
    window.addEventListener('resize', function () {
        if (window.innerWidth < 1300 && !hasSetup) {
            initNav();
        }
    });

    // -- get all a tags in .nav if we are below 1300px
    if (window.innerWidth < 1300) {
        let links = document.querySelectorAll('.header .nav a');
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                // -- remove m-toggle class from body
                document.body.classList.remove('m-toggle');
            });
        });
    }

});




// -- [GLOBAL] on reszie get the header height and set it as a css var



const getHeaderHeight = () => {

    const header = document.querySelector('.header');

    // -- set timeout to allow for the header to render

    setTimeout(function() { 
    
        let headerHeight = header.offsetHeight;

        document.documentElement.style.setProperty('--header-height', (headerHeight - 18) + 'px');

    }, 1000);

};

document.addEventListener('DOMContentLoaded', function() {

    // -- add a JS class to the body
    document.body.classList.add('js');

    // -- get the header height and assign it as a VAR
    getHeaderHeight();

    window.addEventListener('resize', function() {
            
            getHeaderHeight();
    
    });

});




document.addEventListener('DOMContentLoaded', function () {

 const masthead = document.querySelector('.masthead');
  const contentEl = masthead?.querySelector('.masthead__content');
  if (!masthead || !contentEl) return;

  const imgEl =
    masthead.querySelector('picture > img') ||
    masthead.querySelector(':scope > img');
  if (!imgEl) return;

  const cfg = {
    // Image: scale UP
    image: { start: 0.00, end: 0.80, min: 1.00, max: 1.20 },
    // Content: fade OUT
    content: { start: 0.15, end: 0.90, max: 1.00, min: 0.00 }
  };

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  const clamp01 = v => Math.max(0, Math.min(1, v));
  const map = (x, a, b, c, d) => c + (d - c) * clamp01(a === b ? 0 : (x - a) / (b - a));

  let running = false;
  let rafId = null;

  const tick = () => {
    const rect = masthead.getBoundingClientRect();
    const h = rect.height || 1;
    const progress = clamp01(-rect.top / h);

    const imgScale = map(progress, cfg.image.start, cfg.image.end, cfg.image.min, cfg.image.max);
    const contentOpacity = map(progress, cfg.content.start, cfg.content.end, cfg.content.max, cfg.content.min);

    masthead.style.setProperty('--img-scale', imgScale.toFixed(4));
    contentEl.style.setProperty('--content-opacity', contentOpacity.toFixed(4));

    if (running) rafId = requestAnimationFrame(tick);
  };

  const io = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
      if (isVisible && !running) {
        running = true;
        cancelAnimationFrame(rafId);
        tick();
      } else if (!isVisible && running) {
        running = false;
        cancelAnimationFrame(rafId);
      }
    },
    { root: null, rootMargin: '50% 0px 50% 0px', threshold: 0 }
  );

  io.observe(masthead);

  window.addEventListener('load', () => {
    masthead.style.setProperty('--img-scale', cfg.image.min.toFixed(4));
    contentEl.style.setProperty('--content-opacity', cfg.content.max.toFixed(4));
    tick();
  }, { passive: true });

  window.addEventListener('resize', () => running && tick(), { passive: true });

});




document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.clipReveal');
  if (!items.length) return;

  const io = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target); // reveal once
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -10% 0px', // trigger just before fully in view
      threshold: 0
    }
  );

  items.forEach(el => io.observe(el));
})

document.addEventListener('DOMContentLoaded', function () {
  
const headerFigure = document.querySelector('header figure');
  if (!headerFigure) return;

  const onScroll = () => {
    if (window.scrollY > 2) {
      headerFigure.classList.add('scrolled');
      window.removeEventListener('scroll', onScroll);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });

});


document.addEventListener('change', e => {
  if (!e.target.matches('.file-upload__input')) return

  const label = e.target.closest('.file-upload__label')
  const text = label.querySelector('.file-upload__text')

  if (e.target.files.length) {
    text.hidden = false
    text.textContent = e.target.files[0].name
  } else {
    text.hidden = true
    text.textContent = ''
  }
})



// on click .cat-nav-toggle toggle class 'open' on .cat-nav
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.cat-nav-toggle');
  const catNav = document.querySelector('.cat-nav ul');

  if (!toggle || !catNav) return;

  toggle.addEventListener('click', function () {
    catNav.classList.toggle('open');
  });
}); 


// -- when we scoll down the page pass 10px add class 'scrolled' to .header
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header');

  if (!header) return;

  const onScroll = () => {
    if (window.scrollY > 10) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
})


document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.panel__icon[data-animate]');

  if (!items.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  items.forEach(item => {
    const valueEl = item.querySelector('.stat__value');
    if (!valueEl) return;

    const raw = valueEl.textContent.trim();
    const match = raw.match(/^([\d,.]+)(.*)$/);

    if (!match) return;

    const target = parseFloat(match[1].replace(/,/g, ''));
    const suffix = match[2] || '';
    const duration = 2000;

    if (prefersReducedMotion) {
      valueEl.textContent = target.toLocaleString() + suffix;
      return;
    }

    let startTime = null;

    const animate = time => {
      if (!startTime) startTime = time;
      const progress = Math.min((time - startTime) / duration, 1);

      const current = Math.floor(progress * target);
      valueEl.textContent = current.toLocaleString() + suffix;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        valueEl.textContent = target.toLocaleString() + suffix;
      }
    };

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        requestAnimationFrame(animate);
        observer.disconnect();
      }
    }, {
      threshold: 0.4
    });

    observer.observe(item);
  });
});